export { default } from './TableData';



// WEBPACK FOOTER //
// ./src/design-system/molecules/TableData/index.jsx